import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { GET_AFE_FLEET_ITEM_RETURN_TO_REQUESTOR, GET_ASSET_FLEET_ITEM_RETURN_TO_REQUESTOR, GET_FLEET_ITEM_RETURN_TO_REQUESTOR } from 'Store/FleetManagement/FleetItemReturnToRequestor/FleetItemReturnToRequestorType';
import { setAssetFleetItemReturnToRequestor, setFleetItemReturnToRequestor } from 'Store/FleetManagement/FleetItemReturnToRequestor/FleetItemReturnToRequestorAction';
import OrderManagementApiService from 'Service/OrderManagement/OrderManagementApiService';

function* FleetItemReturnSaga(req: any): any {
    try {
        yield put(globalLoaderText("Return to Requestor Fleet Item...."));
        let payloadData : IPayload= {
            apiType : apiType.OrderManagement,
            endpoint : `returntorequestor`,
            apiMethod :  apiMethod.POST,
            payload : req?.payload
        }
        const response = yield call(
            OrderManagementApiService.post,API_URL.PostWebApp,payloadData
            
        );
        if (response) {
            yield put(setFleetItemReturnToRequestor({isReturned: true ,response : response,fleetRequestDetailId : req.payload.fleetDetailId}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setFleetItemReturnToRequestor({isReturned: false ,response : null,fleetRequestDetailId : req.payload.fleetDetailId}))
        yield put(globalLoaderText(""));
    }
}

function* AssetFleetItemReturnSaga(req: any): any {
    try {
        yield put(globalLoaderText("Return to Requestor Asset Fleet Item...."));

        let payloadData : IPayload= {
            apiType : apiType.OrderManagement,
            endpoint : `returntorequestor/asset`,
            apiMethod :  apiMethod.POST,
            payload : req?.payload
        }
        const response = yield call(
            OrderManagementApiService.post, API_URL.PostWebApp, payloadData        
        );
        if (response) {
            yield put(setAssetFleetItemReturnToRequestor({isReturned: true ,response : response,fleetRequestDetailId : req.payload.fleetDetailId}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setAssetFleetItemReturnToRequestor({isReturned: false ,response : null,fleetRequestDetailId : req.payload.fleetDetailId}))
        yield put(globalLoaderText(""));
    }
}

function* AfeFleetItemReturnSaga(req: any): any {
    try {
        yield put(globalLoaderText("Return to Requestor Afe Fleet Item...."));

        let payloadData : IPayload= {
            apiType : apiType.OrderManagement,
            endpoint : `returntorequestor/afe`,
            apiMethod :  apiMethod.POST,
            payload : req?.payload
        }
        const response = yield call(
            OrderManagementApiService.post, API_URL.PostWebApp, payloadData        
        );
        if (response) {
            yield put(setAssetFleetItemReturnToRequestor({isReturned: true ,response : response,fleetRequestDetailId : req.payload.fleetDetailId}))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setAssetFleetItemReturnToRequestor({isReturned: false ,response : null,fleetRequestDetailId : req.payload.fleetDetailId}))
        yield put(globalLoaderText(""));
    }
}

function* watchGetFleetItemCancel() {
    yield takeEvery(GET_FLEET_ITEM_RETURN_TO_REQUESTOR, FleetItemReturnSaga)
    yield takeEvery(GET_ASSET_FLEET_ITEM_RETURN_TO_REQUESTOR, AssetFleetItemReturnSaga)
    yield takeEvery(GET_AFE_FLEET_ITEM_RETURN_TO_REQUESTOR, AfeFleetItemReturnSaga)
}

export default function* combinedSaga() {
    yield all([
        watchGetFleetItemCancel()
    ])
}
